import { render } from "./MenuItem.vue?vue&type=template&id=318d8442&scoped=true"
import script from "./MenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItem.vue?vue&type=script&setup=true&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=318d8442&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318d8442"],['__file',"src/components/MenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "318d8442"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('318d8442', __exports__)) {
    api.reload('318d8442', __exports__)
  }
  
  module.hot.accept("./MenuItem.vue?vue&type=template&id=318d8442&scoped=true", () => {
    api.rerender('318d8442', render)
  })

}


export default __exports__